/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconHuiyuanzhongxin: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M837.26208 92.416l3.328 4.992 165.546667 263.68a117.461333 117.461333 0 0 1-10.24 138.666667l-3.925334 4.437333-432.810666 413.866667a64.768 64.768 0 0 1-91.733334 2.304l-2.389333-2.346667-432.810667-413.866667A117.418667 117.418667 0 0 1 15.032747 366.165333l3.029333-5.077333 165.546667-263.637333a116.778667 116.778667 0 0 1 92.842666-54.613334L282.467413 42.666667h459.264c38.016 0 73.685333 18.56 95.573334 49.749333z m-85.888 17.322667H270.60608c-11.946667 0-23.296 5.546667-30.677333 14.976L237.624747 128 67.21408 402.688a39.168 39.168 0 0 0 2.261333 44.8l2.474667 2.901333L512.099413 875.349333l445.098667-424.96c10.538667-11.093333 16.981333-27.136 11.605333-40.96l-1.493333-3.413333-1.877333-3.328L784.312747 128a38.954667 38.954667 0 0 0-28.970667-18.048l-3.968-0.213333z m-83.2 295.893333l39.936 43.093333L512.099413 638.293333l-193.706666-189.568 37.632-43.093333L512.099413 562.133333l156.074667-156.501333z"
        fill={getIconColor(color, 0, '#000000')}
      />
    </svg>
  );
};

IconHuiyuanzhongxin.defaultProps = {
  size: 18,
};

export default IconHuiyuanzhongxin;
